import { MouseEventHandler } from 'react';

import { CmsTileModalCloseButton } from 'modules/cms/modals/TileModal/CloseButton/CmsTileModalCloseButton';

import {
  TileModalDesktopHeaderBlueLine,
  TileModalDesktopHeaderCloseHolder,
  TileModalDesktopHeaderHolder,
} from './CmsTileModalDesktopHeader.styled';

type Props = {
  onClose: MouseEventHandler<HTMLButtonElement>;
};

export function CmsTileModalDesktopHeader({ onClose }: Props) {
  return (
    <TileModalDesktopHeaderHolder>
      <TileModalDesktopHeaderBlueLine />

      <TileModalDesktopHeaderCloseHolder>
        <CmsTileModalCloseButton onClick={onClose} />
      </TileModalDesktopHeaderCloseHolder>
    </TileModalDesktopHeaderHolder>
  );
}
